import { useEffect, useState } from 'react';
import { type TrackReferenceOrPlaceholder, useSpeakingParticipants } from '@livekit/components-react';
import { Track } from 'livekit-client';

const SPEAKER_SWITCH_DELAY_MS = 1500;

export function useSpeakerTrack(tracks: TrackReferenceOrPlaceholder[]): TrackReferenceOrPlaceholder | undefined {
    const speakingParticipants = useSpeakingParticipants();
    const [stageIdentity, setStageIdentity] = useState<string | null>(null);

    const stageIsSpeaking = speakingParticipants.some((participant) => participant.identity === stageIdentity);
    const nextSpeaker = stageIsSpeaking
        ? null
        : (speakingParticipants.find((participant) => !participant.isLocal)?.identity ?? null);

    useEffect(() => {
        if (nextSpeaker === null) return;
        const timeout = setTimeout(() => {
            setStageIdentity(nextSpeaker);
        }, SPEAKER_SWITCH_DELAY_MS);
        return () => {
            clearTimeout(timeout);
        };
    }, [nextSpeaker]);

    const cameraTracks = tracks.filter((track) => track.source === Track.Source.Camera);
    const remoteCameraTracks = cameraTracks.filter((track) => !track.participant.isLocal);
    return (
        remoteCameraTracks.find((track) => track.participant.identity === stageIdentity) ??
        remoteCameraTracks[0] ??
        cameraTracks[0]
    );
}
